// components/common/ToggleLabelSwitch.jsx
import * as React from 'react';
import { FormControl, Switch as SwitchUI, FormLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    '& .MuiFormLabel-root': {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
    },
    '& .MuiSwitch-root .MuiSwitch-thumb': {
        borderRadius: '4px',
    },
}));

export const Switch = ({ checked, onChange, labelOn = 'Approvals', labelOff = 'Requests', ...props }) => {
    return (
        <StyledFormControl>
            <FormLabel>{checked ? labelOn : labelOff}</FormLabel>
            <SwitchUI
                checked={checked}
                onChange={onChange}
                {...props}
                inputProps={{ 'aria-label': checked ? labelOn : labelOff }}
            />
        </StyledFormControl>
    );
};
